export default {
  code: 'ja',
  messages: {
    required: '{_field_}は必須項目です',
    required_if: '{_field_}を入力してください',
    excluded: '登録済みの{_field_}です',
    numeric: '{_field_}には数値を入力してください',
    max: '{_field_}は{length}文字以内で入力してください',
  }
}
